
<i [ngClass]="value.icon" class="calendar-mood-icon me-2"
   (click)="isIconClicked = !isIconClicked; isOpen = false" type="button" cdkOverlayOrigin #moodIcon="cdkOverlayOrigin"
   (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <sup [hidden]="!value.comment">
        <i class="far fa-comment"></i>
    </sup>
</i>

@if (value.comment) {
    <ng-template cdkConnectedOverlay
                 cdkConnectedOverlayPanelClass="moodPanel"
                 [cdkConnectedOverlayOrigin]="moodIcon"
                 [cdkConnectedOverlayOpen]="isOpen || isIconClicked"
                 [cdkConnectedOverlayPositions]="overlayPositions">
        <div class="mood-icon-tooltip position-relative">
            <div [innerHtml]="value.comment?.body | removeGifUrls: value.comment?.linkPreviews | linky"></div>
            @for (linkPreview of value.comment?.linkPreviews; track linkPreview.url){
                @if(linkPreview.url.slice(-4) === '.gif'){
                    <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
                }
            }
        </div>
        
    </ng-template>
}
